import React, { useState } from 'react'
import { Card, CardProps, Flex, Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import clsx from 'clsx'
import { ManagedForm } from '../public-form'

type FormLinkPreviewProps = CardProps & { form: ManagedForm }

export function FormLinkPreview({ form, className, ...props }: FormLinkPreviewProps) {
    const { t } = useTranslation()
    const [failedImage, setFailedImage] = useState<string>()
    const published = form.enabled ? form.published : null
    const imageUrl = `${form.url}/preview.png?v=${form.version}`
    const description = published?.introduction.trim().replace(/\s+/g, ' ') ?? ''
    const shortDescription = [...description].slice(0, 200).join('') + ([...description].length > 200 ? '…' : '')

    return (
        <Card
            size="small"
            {...props}
            className={clsx('w-full max-w-[480px] overflow-hidden', className)}
            cover={
                published &&
                (failedImage === imageUrl ? (
                    <Flex
                        align="center"
                        justify="center"
                        className="aspect-[1200/630] bg-gray-50 p-4"
                    >
                        <Typography.Text type="secondary">
                            {t('Could not load the link preview image.')}
                        </Typography.Text>
                    </Flex>
                ) : (
                    <img
                        src={imageUrl}
                        alt={`${published.brandName} — ${published.heading}`}
                        width={1200}
                        height={630}
                        className="block aspect-[1200/630] w-full object-contain"
                        onError={() => setFailedImage(imageUrl)}
                    />
                ))
            }
        >
            {published ? (
                <Flex
                    vertical
                    gap={4}
                >
                    <Typography.Text type="secondary">{new URL(form.url).hostname}</Typography.Text>
                    <Typography.Paragraph
                        strong
                        className="mb-0 break-normal [overflow-wrap:anywhere]"
                    >
                        {published.heading}
                    </Typography.Paragraph>
                    {shortDescription && (
                        <Typography.Paragraph
                            type="secondary"
                            className="mb-0 break-normal [overflow-wrap:anywhere]"
                        >
                            {shortDescription}
                        </Typography.Paragraph>
                    )}
                </Flex>
            ) : (
                <Typography.Text type="secondary">{t('Publish the form to see its link preview.')}</Typography.Text>
            )}
        </Card>
    )
}
